// extracted by mini-css-extract-plugin
export default {"advantageList":"AdvantageList_advantageList__0sdCN","advantageItem":"AdvantageList_advantageItem__eNtud"};